import { produce } from "immer";
import { modules } from "../../constants";
import { getShowHideKey } from '../../market-share/helpers/helpers';

export const actions = (set, get) => ({
    setListingType: listingType => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (selectedModule !== modules.marketShare.totals) return;
        const moduleState = state[get().selectedModule];
        moduleState.listingType = listingType;
    }), false, 'setMarketShareTotalsListingType'),
    resetMSPersistedData: () => set(produce(state => {
        if (get().selectedModule !== modules.marketShare.totals
            && get().selectedModule !== modules.marketShare.coverage
        ) return;
        
        const moduleState = state[get().selectedModule];
        moduleState.listingType = undefined;
        moduleState.listingViewId = undefined;
        moduleState.showHideOptions = {};
    })),
    setMSListingViewId: listingViewId => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (selectedModule !== modules.marketShare.totals
            && selectedModule !== modules.marketShare.coverage) return;
        const moduleState = state[get().selectedModule];
        moduleState.listingViewId = listingViewId;
    }), false, 'setMarketShareListingViewId'),
    setMSshowHideOptions: (listingType, listingViewId, updatedOptions) => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (selectedModule !== modules.marketShare.totals
            && selectedModule !== modules.marketShare.coverage
        ) return;
        if (!listingViewId) return;
        if (selectedModule === modules.marketShare.totals && !listingType) return;
        const moduleState = state[get().selectedModule];
        if (!moduleState.showHideOptions) {
            moduleState.showHideOptions = {};
        }
        moduleState.showHideOptions[getShowHideKey(listingType, listingViewId)] = {
            options: updatedOptions?.options ?? [],
            columns: updatedOptions?.columns ?? []
        }
    }), false, 'setMSshowHideOptions'),
    setMSselectedColumnId: (clickedOptionId) => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (selectedModule !== modules.marketShare.totals
            && selectedModule !== modules.marketShare.coverage
        ) return;
        const moduleState = state[get().selectedModule];
        moduleState.selectedColumnId = clickedOptionId;
    }), false, 'setMSSelectedColumnId'),
});
